import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  applicantApplicationsRoute,
  enterpriseTagsKey,
  enterpriseTagsList,
  errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useGetTagsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  enabled: boolean;
  selectedCompanyId?: string | number;
};

export const useGetTags = ({
  setErrorText = () => { },
  enabled,
  selectedCompanyId
}: useGetTagsProps) => {
  const {
    data: tagsData,
    isFetching: isLoadingTags,
  } = useQuery({
    queryKey: [enterpriseTagsKey, selectedCompanyId],
    enabled: Boolean(enabled && selectedCompanyId),
    queryFn: () => {
      return axiosInstance
        .get(enterpriseTagsList + `?company_id=${selectedCompanyId}`)
        .then((res) => res.data);
    },
    onSuccess: (data) => {
      if (data.object) {
        setErrorText('');
      }
      if (data.status !== 200) {
        setErrorText(data.message);
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
    refetchOnWindowFocus: false,
  });

  return {
    tagsData,
    isLoadingTags
  };
};
